<template>
    <div style="display: flex; flex-direction: row; align-items: center;">
        <div v-if="menuFeaturedConfig && menuFeaturedConfig.length>0" style="display: flex; flex-direction: row; align-items: center;">
            <v-btn
                v-for="(item, index) in menuFeaturedConfig"
                :key="index"
                color="primary"
                dark
                text
                @click="onOptionClick(item)"
                :style="`margin-right: 8px; margin-bottom: 0; border: none; box-shadow: none; opacity: ${isMenuItemActive(item) ? '1' : '0.88'}; font-weight: ${isMenuItemActive(item) ? '600' : '400'};`"
            >
                <v-icon v-if="item.icon" small class="mr-2">{{ resolveMenuIcon(item.icon) }}</v-icon>{{ st(item.label) }}
            </v-btn>
        </div>
    <v-menu offset-y left :close-on-click="true" v-if="menuConfig && menuConfig.length>0">
        <template v-slot:activator="{ on, attrs }">
        <v-btn  color="primary" dark v-bind="attrs" v-on="on" text style="min-width: auto; padding-left: 0 !important; padding-right: 0 !important;">
            <span v-if="!compact">{{ $t('wkt.admin.em.header.action-menu') }}</span>
            <v-icon small class="mr-0">{{compact?'more_vert':'expand_more'}}</v-icon>
        </v-btn>
        </template>
        <v-list dense class="menu-panel-list">
        <v-list-item
            v-for="(item, index) in menuConfig" :key="index"
            @click="onOptionClick(item)"
            style="min-height: 40px; padding-left: 12px; padding-right: 12px; cursor: pointer;"
        >
            <div style="display: flex; align-items: center; justify-content: flex-start; width: 100%; text-align: left;">
                <i
                    v-if="item.icon"
                    class="material-icons notranslate"
                    aria-hidden="true"
                    style="margin-right: 8px; flex: 0 0 18px; width: 18px; min-width: 18px; max-width: 18px; display: inline-block; overflow: hidden; white-space: nowrap; font-family: 'Material Icons'; font-size: 18px; line-height: 18px; text-align: center; vertical-align: middle; text-transform: none; letter-spacing: normal; font-feature-settings: 'liga'; -webkit-font-feature-settings: 'liga';"
                >{{ resolveMenuIcon(item.icon) }}</i>
                <span style="display: block; flex: 0 1 auto; text-align: left;">{{ st(item.label) }}</span>
            </div>
        </v-list-item>
        </v-list>
    </v-menu>
    </div>
</template>
 
 <script> 
 import BaseModule from '../../common/BaseModule.js'

 export default {
   name: 'MenuPanel',
   props: ['config','context','compact'],
   mixins: [BaseModule],
   data() {
       return {
            menuFeaturedConfig: [],
            menuConfig: [],
            menuContext: {},
       }
   },
    mounted() {
        this.menuContext = this.context;
        this.syncMenuConfig(this.config);
    },watch: {
       context: function(context) { 
        this.menuContext=context;
      },
      config: function(config) { 
        this.syncMenuConfig(config);
    }
     },
    methods: {
        resolveDynamicValue(value) {
            if (value == null) {
                return value;
            }

            if (typeof value === 'string' && this.menuContext && Object.prototype.hasOwnProperty.call(this.menuContext, value)) {
                return this.menuContext[value];
            }

            return value;
        },
        resolveReportParams(reportParams) {
            if (!reportParams || typeof reportParams !== 'object' || Array.isArray(reportParams)) {
                return reportParams;
            }

            return Object.keys(reportParams).reduce((acc, key) => {
                acc[key] = this.resolveDynamicValue(reportParams[key]);
                return acc;
            }, {});
        },
        resolveMenuIcon(icon) {
            if (!icon) {
                return icon;
            }
            const fallbackIcons = {
                auto_awesome: 'content_copy',
                post_add: 'content_copy'
            };
            return fallbackIcons[icon] || icon;
        },
        syncMenuConfig(config) {
            const menu = config && config.menu ? config.menu : [];
            this.menuConfig = menu.filter(item => !item.featured);
            this.menuFeaturedConfig = menu.filter(item => item.featured);
        },
        normalizeFilters(filters) {
            return (filters || [])
                .map(filter => ({
                    fields: JSON.stringify(filter.fields || []),
                    type: filter.type || '',
                    value: JSON.stringify(filter.value)
                }))
                .sort((a, b) => {
                    const left = `${a.fields}:${a.type}:${a.value}`;
                    const right = `${b.fields}:${b.type}:${b.value}`;
                    return left.localeCompare(right);
                });
        },
        isMenuItemActive(item) {
            if (!item || item.type !== 'FILTER_PRESET') {
                return false;
            }

            const currentFilters = this.normalizeFilters(this.menuContext && this.menuContext.filters ? this.menuContext.filters : []);
            const presetFilters = this.normalizeFilters(item.filters || []);

            if (currentFilters.length !== presetFilters.length) {
                return false;
            }

            return currentFilters.every((filter, index) => {
                const preset = presetFilters[index];
                return filter.fields === preset.fields && filter.type === preset.type && filter.value === preset.value;
            });
        },
        onOptionClick(item) {
            let payload = {
                mode:item.mode,
                type:item.type,
                action:item.action,
                payload:item.payload
                  ? (this.menuContext && Object.prototype.hasOwnProperty.call(this.menuContext, item.payload)
                    ? this.menuContext[item.payload]
                    : item.payload)
                  : null,
                filters:item.filters ? item.filters : null,
                reportTypeId: item.reportTypeId ? this.resolveDynamicValue(item.reportTypeId) : null,
                reportParams: item.reportParams ? this.resolveReportParams(item.reportParams) : null,
                menuContext: this.menuContext ? { ...this.menuContext } : null
            }
            this.$emit ('menu-selected',payload);
        }
    }
 };
 </script>
